<template>
  <div class="main row">
    <div class="col-md-12">
      <KTCodePreview v-bind:title="'Chỉnh sửa ngân sách tháng'">
        <template v-slot:preview>
          <b-form @submit.prevent="submitEdit">
            <b-row class="mb-3">
              <b-col cols="3">
                <small class="text-muted">Kỳ</small>
                <div>
                  <strong>{{ periodLabel }}</strong>
                </div>
              </b-col>
              <b-col cols="3">
                <small class="text-muted">Trạng thái</small>
                <div>
                  <b-badge :variant="statusVariant(line.status)">
                    {{ statusName(line.status) }}
                  </b-badge>
                </div>
              </b-col>
              <b-col cols="3">
                <small class="text-muted">Phòng ban</small>
                <div>{{ line.departmentName || line.departmentId }}</div>
              </b-col>
              <b-col cols="3">
                <small class="text-muted">Cửa hàng</small>
                <div>{{ line.storeName || (line.storeId ? line.storeId : 'Cấp phòng ban') }}</div>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col cols="6">
                <b-form-group>
                  <template #label>
                    Số tiền phân bổ <span class="text-danger">*</span>
                  </template>
                  <BInputNumber
                    v-model="form.allocatedAmount"
                    placeholder="0"
                    size="sm"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col cols="12">
                <b-form-group>
                  <template #label>
                    Lý do chỉnh sửa <span class="text-danger">*</span>
                  </template>
                  <b-form-textarea
                    v-model="form.description"
                    rows="3"
                    placeholder="Nhập lý do"
                    required
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <div class="d-flex">
              <b-button
                type="submit"
                variant="primary"
                :disabled="isSaving"
              >
                <i class="fas fa-save"></i>
                {{ isSaving ? 'Đang lưu...' : 'Lưu' }}
              </b-button>
              <b-button
                variant="secondary"
                class="ml-2"
                :disabled="isSaving"
                @click="goBack"
              >
                <i class="fas fa-arrow-left"></i> Quay lại
              </b-button>
            </div>
          </b-form>
        </template>
      </KTCodePreview>
    </div>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import { checkPermission } from '@/utils/saveDataToLocal';
import { makeToastSuccess, makeToastFaile, handleError } from '@/utils/common';
import BInputNumber from '@/view/base/bootstrap/BInputNumber.vue';
import moment from 'moment';
import { BUDGET_STATUS, BUDGET_STATUS_BADGE_VARIANT } from '@/utils/enum';
import { BUDGET_STATUS_NAME } from '@/utils/enum-name';

export default {
  components: { KTCodePreview, BInputNumber },
  data() {
    return {
      line: {},
      form: { id: null, allocatedAmount: 0, description: '' },
      isSaving: false,
      BUDGET_STATUS,
    };
  },
  computed: {
    periodLabel() {
      return this.line?.period ? moment(this.line.period).format('MM/YYYY') : '';
    },
  },
  created() {
    const id = this.$route.query.id;
    if (id) this.fetchDetail(id);
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Kế toán', route: '#' },
      { title: 'Ngân sách', route: '/budget/budget-lines' },
      { title: 'Chỉnh sửa tháng' },
    ]);
  },
  methods: {
    checkPermission,
    makeToastSuccess,
    makeToastFaile,
    statusVariant(val) {
      return BUDGET_STATUS_BADGE_VARIANT[val] || 'secondary';
    },
    statusName(val) {
      return BUDGET_STATUS_NAME[val] || '';
    },
    fetchDetail(id) {
      ApiService.get(`v2/budget-lines/${id}`)
        .then(({ data }) => {
          if (data.status === 200) {
            this.line = data.data || {};
            this.form = {
              id: this.line.id,
              allocatedAmount: Number(this.line.allocatedAmount) || 0,
              description: '',
            };
          } else {
            this.makeToastFaile(data.message);
          }
        })
        .catch((err) => handleError(err));
    },
    submitEdit() {
      if (!this.form?.id) return;
      if (!this.form.description || !this.form.description.trim()) {
        this.makeToastFaile('Vui lòng nhập lý do chỉnh sửa!');
        return;
      }
      this.isSaving = true;
      ApiService.put('v2/budget-lines', this.form)
        .then(({ data }) => {
          this.makeToastSuccess(data.message);
          this.goBack();
        })
        .catch((err) => handleError(err))
        .finally(() => {
          this.isSaving = false;
        });
    },
    goBack() {
      const from = this.$route?.query?.from;
      const q = { id: this.form.id };
      if (from) q.from = String(from);
      this.$router.push({ name: 'detail-budget-line', query: q }).catch(() => {});
    },
  },
};
</script>

